import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../../../auth/service/utils.service';
import { IContentHeader } from '../../../../layout/components/content-header/content-header.component';

@Component({
  selector: 'app-deals-templates-paragraphs',
  templateUrl: './deals-templates-paragraphs.component.html',
  styleUrls: ['./deals-templates-paragraphs.component.scss'],
})
export class DealsTemplatesParagraphsComponent implements OnInit {
  public contentHeader: IContentHeader;

  public activeTab: string = 'box_1';

  box_1: string = null;

  box_2_task: string = null;

  box_2_time_material: string = null;

  box_3: string = null;

  box_4: string = null;

  box_5: string = null;

  box_6_task: string = null;

  box_6_time_material: string = null;

  box_7: string = null;

  box_8: string = null;

  constructor(public _utilService: UtilsService) {
    this.contentHeader = {
      headerTitle: "CONFIGURATIONS.EDIT_PARAGRAPHS_DEALS",
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/',
          },
          {
            name: 'CONFIGURATIONS.CONFIGURATIONS',
            isLink: true,
            link: '/dashboard/configurations',
          },
          {
            name: "CONFIGURATIONS.EDIT_PARAGRAPHS_DEALS",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this._utilService.loadOptions()
      .then(() => {
        setTimeout(() => {
          this.box_1 = this._utilService.themeConfiguration.deal_template_boxes.box_1;
          this.box_2_task = this._utilService.themeConfiguration.deal_template_boxes.box_2_task;
          this.box_2_time_material = this._utilService.themeConfiguration.deal_template_boxes.box_2_time_material;
          this.box_3 = this._utilService.themeConfiguration.deal_template_boxes.box_3;
          this.box_4 = this._utilService.themeConfiguration.deal_template_boxes.box_4;
          this.box_5 = this._utilService.themeConfiguration.deal_template_boxes.box_5;
          this.box_6_task = this._utilService.themeConfiguration.deal_template_boxes.box_6_task;
          this.box_6_time_material = this._utilService.themeConfiguration.deal_template_boxes.box_6_time_material;
          this.box_7 = this._utilService.themeConfiguration.deal_template_boxes.box_7;
          this.box_8 = this._utilService.themeConfiguration.deal_template_boxes.box_8;
        }, 100);
      });
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? '' : tab;
  }

  async edit() {
    this._utilService.showLoading();
    const data = {
      box_1: this.box_1,
      box_2_task: this.box_2_task,
      box_2_time_material: this.box_2_time_material,
      box_3: this.box_3,
      box_4: this.box_4,
      box_5: this.box_5,
      box_6_task: this.box_6_task,
      box_6_time_material: this.box_6_time_material,
      box_7: this.box_7,
      box_8: this.box_8,
    };
    this._utilService.hideLoading();
    await this._utilService.updateOption('deal_template_boxes', data);
  }
}
